import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { AccountCircle, EmojiEventsOutlined, EmojiEventsRounded, PersonPinRounded } from '@mui/icons-material';
import { useStyles } from './styles';

function Header(props) {
  const classes = useStyles();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static"  className={classes.appbarContainer}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={props.handleOnClick}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Riddle Today
          </Typography>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}       
            onClick={() => {
              props.setStatisticsModalOpen(!props.statisticsModalOpen)
            }}     
          >
            <EmojiEventsRounded />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Header;
